module.exports = __webpack_public_path__ + "media/images/photo15-0132a1693763c706ace1f185d918e3b0.png";